import type { Breakpoint } from 'variables/breakpoint';
import useMediaQuery from './useMediaQuery';

export default function useIsMobile() {
    const bp: Breakpoint = '768px';
    const maxWidth = Number.parseInt(bp) - 1;

    return useMediaQuery(`(max-width: ${maxWidth}px)`);
}
